export const useStory = async function (path = "", opts = {}) {
  const { storyblok } = useStores()
  const storyapi = useStoryblokApi()

  const _key = `${path}_${JSON.stringify(opts)}`
  const story = useState(`${_key}-state`)

  onMounted(() => {
    if (story.value && story.value.id) {
      useStoryblokBridge(
        story.value.id,
        (evStory) => (story.value = evStory)
        // bridgeOptions,
      )
    }
  })

  if (!story.value) {
    const { data } = await useAsyncData(_key, async () => {
      const params = {
        ...opts,
      }

      if (storyblok.version) {
        params.version = storyblok.version
      }

      // if (storyblok.version == "published") {
      // }
      params.cv = Date.now()

      return storyapi.get(`cdn/stories/${path}`, params)
    })

    if (data) {
      story.value = data.value?.data.story
    }
  }

  return story
}

export default useStory
